import React from 'react';
import {Link} from 'react-router-dom';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCheckCircle} from '@fortawesome/free-solid-svg-icons';
import type {ReactableColumnDef} from '@deviceinsight/ng-ui-components';
import '@deviceinsight/ng-ui-components';
import type {UpdateJob} from '../types';
import '../types';
import {ADMIN_LIST_TEST_IDS} from '../consts';
import formatTimestamp from '../../common/formatTimestamp';

const jobColumnDefs = (assetGroupId: string): Array<ReactableColumnDef<UpdateJob>> => {
	return [
		{
			name: 'id',
			label: {
				id: 'updatejobs.id',
				defaultValue: 'Update Job Id'
			},
			sortable: true,
			render: ({id}: UpdateJob) => (
				<Link
					to={`/assetgroups/${assetGroupId}/globaljobs/${id}`}
					data-testid={ADMIN_LIST_TEST_IDS.DETAILS_LINK}>
					{id}
				</Link>
			),
			width: '30%'
		},
		{
			name: 'status',
			label: {
				id: 'updatejobs.status',
				defaultValue: 'Status'
			},
			sortable: true,
			render: ({status}: UpdateJob) => status,
			width: '10%'
		},
		{
			name: 'boxBundleData',
			label: {
				id: 'properties.sBox',
				defaultValue: 'KIS.BOX'
			},
			sortable: false,
			render: ({boxBundleData}: UpdateJob) =>
				boxBundleData ? (
					<FontAwesomeIcon
						data-testid={ADMIN_LIST_TEST_IDS.BOX_FW_ICON}
						icon={faCheckCircle}
						color={'green'}
					/>
				) : null,
			width: '10%'
		},
		{
			name: 'lightBundleData',
			label: {
				id: 'properties.sLight',
				defaultValue: 'KIS.LIGHT'
			},
			sortable: false,
			render: ({lightBundleData}: UpdateJob) =>
				lightBundleData ? (
					<FontAwesomeIcon
						data-testid={ADMIN_LIST_TEST_IDS.LIGHT_FW_ICON}
						icon={faCheckCircle}
						color={'green'}
					/>
				) : null,
			width: '10%'
		},
		{
			name: 'ioBundleData',
			label: {
				id: 'properties.kisIo',
				defaultValue: 'KIS.IO'
			},
			sortable: false,
			render: ({ioBundleData}: UpdateJob) =>
				ioBundleData ? (
					<FontAwesomeIcon
						data-testid={ADMIN_LIST_TEST_IDS.KISIO_FW_ICON}
						icon={faCheckCircle}
						color={'green'}
					/>
				) : null,
			width: '10%'
		},
		{
			name: 'latestExecutionDate',
			label: {
				id: 'updatejobs.latestExecutionDate',
				defaultValue: 'Latest execution date'
			},
			sortable: true,
			render: ({latestExecutionDate}: UpdateJob) => formatTimestamp(latestExecutionDate),
			width: '20%'
		},
		{
			name: 'createdAt',
			label: {
				id: 'updatejobs.createdAt',
				defaultValue: 'Created at'
			},
			sortable: true,
			render: ({createdAt}: UpdateJob) => formatTimestamp(createdAt),
			width: '20%'
		}
	];
};

export default jobColumnDefs;
